import React from 'react';
import HomeProjects from '../../HomeProjects/HomeProjects';
import AboutMe from '../AboutMe/AboutMe';
import Banner from '../Banner/Banner';
import Services from '../Services/Services';
import HomeBlog from './HomeBlog/HomeBlog';


const Home = () => {
    return (
        <div>
            <Banner/>
            <AboutMe/>
            <Services/>
            <HomeProjects/>
            <HomeBlog/>
        </div>
    );
};

export default Home;